import React from 'react';
import "./App.css";
import Navigation from "./components/Desktop/Navigation";

const PrivacyPolicy = () => {
    window.scrollTo(0, 0)
    return (
        <>
            <Navigation />
            <div className='termsContainer'>
                <h1 className='termsHeading'>Privacy Policy</h1>
                <p>Privacy policy content goes here.</p>
            </div>
        </>
    )
}

export default PrivacyPolicy;

